import React, { Component } from 'react';
import styled from 'styled-components';
import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.min.css';
import { Norwegian } from "flatpickr/dist/l10n/no.js";
import debounce from 'lodash.debounce';

import WP from 'WP';

import IconSelector from 'partials/IconSelector';

import Media, { ScreenWidth } from 'css/Media';

export class DateRangePicker extends Component {

    componentWillMount() {
        this.checkScreenSize();
    }

    componentDidMount() {
        let { fromDate } = this.props;

        window.addEventListener('resize', debounce(() => this.checkScreenSize()),500);

        flatpickr.l10ns.no.rangeSeparator = ' ─ ';
        flatpickr.l10ns.no.months.shorthand = flatpickr.l10ns.no.months.shorthand.map(month => month.toLowerCase())

        let options = {
            locale: Norwegian,
            mode: 'single',
            minDate: 'today',
            altInput: true,
            altFormat: 'D. j. M Y',
            dateFormat: "Y-m-d\\TH:S", /* 'D. j. M' */
            onChange: this.props.dateHandler,
            showMonths: this.state.isMobile ? 1 : 2,
            arrowTop: false,
        };

        // If we're provided a date we'll populate the flatpickr
        if(fromDate) {
            fromDate = new Date(fromDate);

            options.defaultDate = [
                fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate()
            ];
            //what about time, e.g (08:00) ?
        }

        flatpickr(this.props.reference.current, options);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.checkScreenSize);
    }

    checkScreenSize() {
        let isMobile = false;
        if(ScreenWidth.lessThan('s')) {
            isMobile = true;
        }
        this.setState({isMobile: isMobile});
    }

    render() {
        const { valid } = this.props;

        return (
            <StyledLabel valid={valid} className={this.props.className}>
                <p>{WP.trans.chooseDate}</p>
                <Input
                    ref={this.props.reference}
                    defaultValue={this.props.dateStr || ""}
                    valid={valid ? 1 : 0}
                />
                <StyledIconSelector icon="calender" valid={valid ? 1 : 0} noMargin />
            </StyledLabel>
        )
    }
}

export default DateRangePicker;

const Input = React.forwardRef((props,ref) => (
    <input
        ref={ref}
        className={props.className}
        placeholder={props.placeholder}
        defaultValue={props.defaultValue}
        valid={props.valid}
    />
))

const StyledLabel = styled.label`
    p {
        ${props => props.theme.fonts.h6}
        ${Media.greaterThan('s')`
            padding: 0 0 ${props => props.theme.spacing.contentM} ${props => props.theme.spacing.contentM};
        `}
    }

    >p:first-of-type {
        color: ${props => props.theme.colors.inputText};
    }

    input {
        position: relative;
        width: 100%;
        height: ${props => props.theme.spacing.elementS};
        border: 1px solid ${props => props.valid ? props.theme.colors.input : props.theme.colors.danger };
        box-shadow: none;
        -webkit-appearance: none;
        border-radius: 0;
        ${props => props.theme.fonts.p};
        font-size: 14px;
        padding: 0 25px;
        background-color: ${props => props.theme.colors.negative};
        transition: border .2s ease;

        &:hover,
        &:focus-within {
            border-color: ${props => props.theme.colors.text};
        }

        ~ p {
            color: ${props => props.theme.colors.danger};
            font-size: 14px;
            line-height: 16px;
            padding-top: ${props => props.theme.spacing.contentS};

            ${Media.greaterThan('s')`
                font-size: 16px;
            `}
        }

        ${Media.greaterThan('s')`
            font-size: 18px;
            line-height: 33px;
        `}
    }
`

const StyledIconSelector = styled(IconSelector)`
    position: absolute;
    right: 25px;
    bottom: 58px;
    fill: ${props => props.valid ? props.theme.colors.text : props.theme.colors.danger };

    ${Media.greaterThan('s')`
        bottom: 68px;
    `}
`
